import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { UsersRound, Newspaper, Inbox, CreditCard, Images, ArrowRight } from "lucide-react";
import api from "../../lib/api";
import { PageTitle, Card, Loading, fmtDate } from "../portal/ui";

function Stat({ icon: I, label, value, sub, to, tid }) {
  return (
    <Link to={to} className="group rounded-2xl border border-sapphire-deep/10 bg-white p-6 transition-shadow hover:shadow-heritage" data-testid={tid}>
      <div className="flex items-center justify-between text-gold-deep">
        <I size={20} /><ArrowRight size={15} className="opacity-0 transition-opacity group-hover:opacity-100" />
      </div>
      <p className="mt-5 font-display text-4xl font-semibold text-sapphire-deep">{value}</p>
      <p className="mt-1 font-sans text-xs font-semibold uppercase tracking-widest text-stonegrey">{label}</p>
      {sub && <p className="mt-2 font-sans text-xs text-charcoal/60">{sub}</p>}
    </Link>
  );
}

export default function Overview() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/platform/overview").then(({ data }) => setD(data)); }, []);
  if (!d) return <Loading />;
  return (
    <div data-testid="control-overview">
      <PageTitle eyebrow="Platform Administration" title="Overview" sub="Everything on the Lodge platform at a glance." />
      <div className="grid gap-5 sm:grid-cols-2 xl:grid-cols-5">
        <Stat icon={UsersRound} label="Accounts" value={d.users.total} to="/control-panel/users" tid="stat-users"
          sub={`${d.users.platform_admins} platform admins · ${d.users.cms_users} CMS users · ${d.users.deactivated} deactivated`} />
        <Stat icon={Newspaper} label="Awaiting review" value={d.content.in_review} to="/control-panel/content" tid="stat-review"
          sub={`${d.content.published} published · ${d.content.drafts} drafts`} />
        <Stat icon={Images} label="Media assets" value={d.media} to="/control-panel/media" tid="stat-media" />
        <Stat icon={Inbox} label="New inquiries" value={d.inquiries.new} to="/control-panel/inquiries" tid="stat-inquiries" sub={`${d.inquiries.total} total`} />
        <Stat icon={CreditCard} label="Dues outstanding" value={d.dues.due} to="/control-panel/dues" tid="stat-dues" sub={`${d.dues.paid} paid`} />
      </div>
      <Card className="mt-10">
        <div className="flex items-center justify-between">
          <h2 className="font-display text-2xl font-semibold text-sapphire-deep">Recent activity</h2>
          <Link to="/control-panel/activity" className="link-underline text-sm" data-testid="overview-all-activity">Full log <ArrowRight size={14} /></Link>
        </div>
        <ul className="mt-4 divide-y divide-sapphire-deep/5" data-testid="overview-recent">
          {d.recent.map((a) => (
            <li key={a.id} className="flex flex-wrap items-baseline gap-x-3 py-3 font-sans text-sm">
              <span className="font-semibold text-sapphire-deep">{a.actor_name || a.actor_email || "Unknown"}</span>
              <span className="text-charcoal/80">{a.action}</span>
              {a.target && <span className="text-gold-deep">{a.target}</span>}
              <span className="ml-auto text-xs text-stonegrey">{fmtDate(a.at, true)}</span>
            </li>
          ))}
          {!d.recent.length && <li className="py-3 font-sans text-sm text-stonegrey">No activity yet.</li>}
        </ul>
      </Card>
    </div>
  );
}
